import "./App.css"
import React, { useState, useEffect } from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import Recipes from "./components/recipes/Recipes"
import Favorites from "./components/favorites/Favorites"
import MealPlanner from "./components/mealPlanner/MealPlanner"
import Login from "./components/login/Login"
import SidebarHoc from "./components/Sidebar/SidebarHoc"
import "./App.css"
import { serverAPI } from "./services/api/apiParams"

export const sidebarContext = React.createContext()
export const userContext = React.createContext()

function App() {
  const [user, setUser] = useState({})

  // if user already logged (jwt): get user
  const getUser = async () => {
    if (!user.id) {
      try {
        const result = await serverAPI.get("api/user", {
          headers: {
            Accept: "application/json",
          },
        })
        setUser(result.data)
      } catch (e) {
        console.log(e)
      }
    }
  }

  const [show, setShow] = useState(false)
  const handleShowSide = () => setShow(true)

  useEffect(() => {
    getUser()
  }, [])

  return (
    <div className='appDiv'>
      <Router>
        <Switch>
          <sidebarContext.Provider value={handleShowSide}>
            <userContext.Provider value={{ user, setUser }}>
              <SidebarHoc show={show} setShow={setShow}></SidebarHoc>
              <Route exact path='/'>
                <Recipes />
              </Route>{" "}
              <Route exact path='/meal-planner'>
                <MealPlanner user={user}></MealPlanner>
              </Route>
              <Route exact path='/favorites'>
                <Favorites user={user}></Favorites>
              </Route>
              <Route exact path='/Login'>
                <Login></Login>
              </Route>
            </userContext.Provider>
          </sidebarContext.Provider>
        </Switch>
      </Router>
    </div>
  )
}

export default App
